
import * as actions from 'actions';
import emojisMaker from 'reducersMakers/emojisMaker';

export default emojisMaker({
  showType: actions.FORUM_EMOJIS_SHOW,
  closeType: actions.FORUM_EMOJIS_HIDE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/emojis/forumContribute/reducer.js
 **/